module.exports = __webpack_public_path__ + "static/media/colorstory.63400db9.png";